import {
  NEKOSEI_GAME_FULL_NAME,
  NEKOSEI_PET_CAT_COUNT_LABEL,
} from "@/domains/nekosei/NekoseiGameName";
import AdoptionImage from "@/assets/images/tools/adoption.webp";
import AgeImage from "@/assets/images/tools/age.webp";
import BodyConditionImage from "@/assets/images/tools/body-condition.webp";
import CalorieImage from "@/assets/images/tools/calorie.webp";
import EventsImage from "@/assets/images/tools/events.webp";
import FirstCatImage from "@/assets/images/tools/first-cat.webp";
import FoodsSafetyImage from "@/assets/images/tools/foods-safety.webp";
import FoodsImage from "@/assets/images/tools/foods.webp";
import NekoseiImage from "@/assets/images/tools/nekosei.webp";
import ReferenceImage from "@/assets/images/tools/reference.webp";
import TransitionImage from "@/assets/images/tools/transition.webp";
import VideosHealingImage from "@/assets/images/tools/videos-healing.webp";
import VideosLearningImage from "@/assets/images/tools/videos-learning.webp";
import WelcomePlanImage from "@/assets/images/tools/welcome-plan.webp";

export interface MenuItem {
  title: string;
  description: string;
  href: string;
  imageSrc: string;
}

export interface MenuCategory {
  id: string;
  title: string;
  items: readonly MenuItem[];
}

export const MENU_CATEGORIES: readonly MenuCategory[] = [
  {
    id: "welcome",
    title: "猫を迎える",
    items: [
      {
        title: "猫を迎える費用を知る",
        description: "猫を迎えるときの費用目安を、条件を選んで確認できます。",
        href: "/welcome-plan/",
        imageSrc: WelcomePlanImage,
      },
      {
        title: "保護猫と出会う場所を探す",
        description:
          "地域から保護猫施設・譲渡型保護猫カフェ・動物愛護センターを探せます。",
        href: "/adoption/",
        imageSrc: AdoptionImage,
      },
    ],
  },
  {
    id: "health",
    title: "猫の健康を見守る",
    items: [
      {
        title: "年齢を人間に換算する",
        description:
          "猫の年齢から、人間でいうと何歳かとライフステージがわかります。",
        href: "/age/",
        imageSrc: AgeImage,
      },
      {
        title: "体型をチェックする",
        description:
          "シルエットと見比べて、体型の目安（BCS）と理想体重がわかります。",
        href: "/body-condition/",
        imageSrc: BodyConditionImage,
      },
      {
        title: "猫が食べても大丈夫か調べる",
        description:
          "猫に与えてはいけない食べ物と、注意が必要な食べ物を調べられます。",
        href: "/foods-safety/",
        imageSrc: FoodsSafetyImage,
      },
    ],
  },
  {
    id: "meal",
    title: "猫のごはんを考える",
    items: [
      {
        title: "ごはん量を計算する",
        description:
          "猫の体重と活動レベルからRER/DERとごはんの必要な量を計算します。",
        href: "/calorie/",
        imageSrc: CalorieImage,
      },
      {
        title: "ごはんを探す",
        description:
          "Nekometryで対応しているキャットフードのカロリーや栄養成分を確認できます。",
        href: "/calorie/foods/",
        imageSrc: FoodsImage,
      },
      {
        title: "新しいごはんへ切り替える",
        description:
          "愛猫のフードを安全に切り替えるためのプランを立てられます。",
        href: "/calorie/transition/",
        imageSrc: TransitionImage,
      },
    ],
  },
  {
    id: "game",
    title: "ゲームで体験する",
    items: [
      {
        title: "はじめて猫を飼う暮らしを体験する",
        description:
          "猫を迎えてからの6か月を、ドット絵のお世話ゲームで体験できます。",
        href: "/game/first-cat/",
        imageSrc: FirstCatImage,
      },
      {
        title: NEKOSEI_GAME_FULL_NAME,
        description: `日本の飼い猫${NEKOSEI_PET_CAT_COUNT_LABEL}のうちの1匹として、生まれる場所も飼い主の呼び方も選べない一生を数分で生きるゲームです。`,
        href: "/game/nekosei/",
        imageSrc: NekoseiImage,
      },
    ],
  },
  {
    id: "media",
    title: "猫の記事・動画を見る",
    items: [
      {
        title: "記事を読む",
        description:
          "猫を迎える費用やごはんの量など、猫との暮らしに役立つ記事を紹介します。",
        href: "/articles/",
        imageSrc: ReferenceImage,
      },
      {
        title: "学びの動画を見る",
        description: "猫との暮らしやごはんについて学べる動画を紹介します。",
        href: "/videos/?tag=learning",
        imageSrc: VideosLearningImage,
      },
      {
        title: "癒やしの動画を見る",
        description: "猫との時間を楽しめる動画を紹介します。",
        href: "/videos/?tag=healing",
        imageSrc: VideosHealingImage,
      },
      {
        title: "猫のイベントを探す",
        description:
          "猫フェスや即売会、猫の展示などの開催予定を、地方や年ごとに探せます。",
        href: "/events/",
        imageSrc: EventsImage,
      },
    ],
  },
];
